import { hide, show } from "./common";

interface CollapsableElements {
    checkbox: HTMLInputElement;
    collapsableArea: HTMLElement;
}

export default class Collapsable {
    private checkboxId: string;
    private collapsableAreaId: string;
    private elements: CollapsableElements;

    constructor(checkboxId: string, collapsableAreaId: string) {
        this.checkboxId = checkboxId;
        this.collapsableAreaId = collapsableAreaId;
        this.init();
    }

    refreshCollapsable(): void {
        this.init();
    }

    private init(){
        this.initElements();
        if (!this.elements.checkbox || !this.elements.collapsableArea)
            return;

        this.subscribeElements();
        this.updateAreaVisiblity();
    }

    private initElements(): void {
        this.elements = {
            checkbox: <HTMLInputElement> document.getElementById(this.checkboxId),
            collapsableArea: document.getElementById(this.collapsableAreaId)
        };
    }

    private subscribeElements(): void {
        this.elements.checkbox.addEventListener('change', () => this.updateAreaVisiblity());
    }

    private updateAreaVisiblity(): void {
        if(this.isOpen()){
            show(this.elements.collapsableArea);
        } else {
            hide(this.elements.collapsableArea);
        }
    }

    private isOpen = () => {
        return this.elements?.checkbox?.checked ?? false;
    }

}
